import { matchConfigurationDataWithDefault } from "@/lib/utils/crm/matchConfigurationData";
import { sortByCreatedAt } from "@/lib/utils/sortByCreatedAt";
import { countErrorsInARow, getExportDataTransformedShape, isString, required, transformParametersToObjectWithNames, validate, validateObjectKeys } from "../..";

export const refineData = (data: getExportDataTransformedShape) => {
    const temp = data.survey.question
    .sort(sortByCreatedAt)
    .map(q=>{
        const matchedConfiguration = matchConfigurationDataWithDefault(data.crm, data.crm_project, data.crm_config, q)
        const validResponse = q.response.filter(r => r.valid)[0];
        return {
            questionId: validate<string>(q.id,[required],{
                fieldName: "Question ID"
            }),
            "Question": validate<string>(q.question,[required, isString],{
                fieldName: "Question"
            }),
            "Field Type": validate<string>(q.field_type,[required, isString],{
                fieldName: "Field Type"
            }),
            "Values": validate<string>(validResponse?.field_value,[required, isString],{
                fieldName: "Values"
            }),
            ...validateObjectKeys(transformParametersToObjectWithNames(matchedConfiguration?.parameter?.crm),[required]),
            ...validateObjectKeys(transformParametersToObjectWithNames(matchedConfiguration?.parameter?.project),[required]),
            ...validateObjectKeys(transformParametersToObjectWithNames(matchedConfiguration?.parameter?.survey),[required]),
            ...validateObjectKeys(transformParametersToObjectWithNames(matchedConfiguration?.parameter?.question),[required]),
        }
    })
    .sort((a,b)=>countErrorsInARow(a) - countErrorsInARow(b))
    return {
        ...data,
        refinedData: temp,
    }
}


